// The gift share page's two enhancements: copy the link, and hand it to the
// phone's own share sheet.
//
// NOT IN packs/, for the reason mock_composer.js records; imported by
// packs/application.js beside password_toggle.js, whose shape this is. The
// page works without it — the link sits in a readonly field a person can
// select, and WhatsApp is a plain link — so this is the enhancement, and
// failing means falling back to exactly that.
//
// - [data-gift-copy] copies the value of the field named by its
//   `data-gift-copy` (an id), and says so on the button for two seconds.
// - [data-gift-native-share] ships `hidden`, and is shown only where the
//   browser has navigator.share — which on a phone is every app the person
//   actually uses, not just the one we thought of.
// - The course page's share panel (courses/_share) reuses both, and every
//   control inside a [data-course-share] that carries [data-share-channel]
//   reports its tap to CourseShareEventsController. A report that fails is
//   one row the admin's count misses; the share itself is never held up.

const COPIED_FOR_MS = 2000;

function copy(button) {
  const field = document.getElementById(button.dataset.giftCopy);
  if (!field) return;

  const done = () => {
    const label = button.dataset.label || button.textContent;
    button.dataset.label = label;
    button.textContent = "Copied";
    setTimeout(() => { button.textContent = label; }, COPIED_FOR_MS);
  };

  if (navigator.clipboard && window.isSecureContext) {
    navigator.clipboard.writeText(field.value).then(done, () => field.select());
  } else {
    field.select();
  }
}

function share(button) {
  navigator.share({ text: button.dataset.shareText, url: button.dataset.shareUrl }).catch(() => {});
}

function init() {
  if (typeof navigator.share === "function") {
    document.querySelectorAll("[data-gift-native-share]").forEach((button) => {
      button.hidden = false;
    });
  }
}

function recordShare(control) {
  const panel = control.closest("[data-course-share]");
  if (!panel || !panel.dataset.shareEventsUrl) return;

  const token = document.querySelector('meta[name="csrf-token"]');
  const body = new URLSearchParams({ course_id: panel.dataset.courseId, channel: control.dataset.shareChannel });

  try {
    fetch(panel.dataset.shareEventsUrl, {
      method: "POST",
      body,
      keepalive: true,
      credentials: "same-origin",
      headers: token ? { "X-CSRF-Token": token.content } : {}
    }).catch(() => {});
  } catch (_error) {
    // The count misses one tap; the reader notices nothing.
  }
}

document.addEventListener("click", (event) => {
  const channelControl = event.target.closest("[data-course-share] [data-share-channel]");
  if (channelControl) recordShare(channelControl);

  const copyButton = event.target.closest("[data-gift-copy]");
  if (copyButton) {
    event.preventDefault();
    copy(copyButton);
    return;
  }

  const shareButton = event.target.closest("[data-gift-native-share]");
  if (shareButton) {
    event.preventDefault();
    share(shareButton);
  }
});

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init);
} else {
  init();
}
